<nz-page-header [nzTitle]="'Reunert Connect Market Place' | locale" class="vaultx-feasibility-header"
  [nzSubtitle]="'Check service availability and connectivity options for a customer location.' | locale"
  [nzBackIcon]="null" (nzBack)="(false)"></nz-page-header>

<div class="vaultx-feasibility-client">
  <ng-container *ngIf="!isDocumentCreated">
    <nz-card class="feasibility-panel form-panel" [nzBordered]="false">
      <div class="panel-heading">
        <div>
          <!-- <h2>{{ "Qualification Details" | locale }}</h2> -->
          <p>{{ "Enter the customer and service requirements." | locale }}</p>
        </div>
      </div>

      <form nz-form nzLayout="vertical" [formGroup]="feasibilityForm" (ngSubmit)="submitFeasibilityRequest()">
        <nz-row [nzGutter]="[20, 8]">
          <nz-col nzXs="24" nzMd="12">
            <nz-form-item>
              <nz-form-label nzRequired>{{ "Customer Name" | locale }}</nz-form-label>
              <nz-form-control [nzValidateStatus]="isFieldInvalid('customerName') ? 'error' : null">
                <nz-input-group nzPrefixIcon="user">
                  <input nz-input formControlName="customerName" [placeholder]="'Enter customer name' | locale" />
                </nz-input-group>
                <div class="validation-message" *ngIf="isFieldInvalid('customerName')">
                  {{ "Customer name is required" | locale }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <nz-col nzXs="24" nzMd="12">
            <nz-form-item>
              <nz-form-label nzRequired>{{ "Decimal GPS Coordinates" | locale }}</nz-form-label>
              <nz-form-control [nzValidateStatus]="isFieldInvalid('coordinates') ? 'error' : null">
                <nz-input-group nzPrefixIcon="environment">
                  <input nz-input formControlName="coordinates"
                    [placeholder]="'Example: -26.12345, 28.12345' | locale" />
                </nz-input-group>
                <div class="validation-message" *ngIf="isFieldInvalid('coordinates')">
                  {{
                  "Please enter a comma between the latitude and longtituted values"
                  | locale
                  }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <nz-col nzXs="24" nzMd="12">
            <nz-form-item>
              <nz-form-label nzRequired>{{ "Speed (Mbps)" | locale }}</nz-form-label>
              <nz-form-control [nzValidateStatus]="isFieldInvalid('speed') ? 'error' : null">
                <nz-select nzShowSearch nzAllowClear formControlName="speed"
                  [nzLoading]="isOptionsLoading" [nzPlaceHolder]="'Select speed' | locale">
                  <nz-option *ngFor="let option of speedOptions" [nzLabel]="option.Name"
                    [nzValue]="option.Code"></nz-option>
                </nz-select>
                <div class="validation-message" *ngIf="isFieldInvalid('speed')">
                  {{ "Speed is required" | locale }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <nz-col nzXs="24" nzMd="12">
            <nz-form-item>
              <nz-form-label nzRequired>{{ "Contract term" | locale }}</nz-form-label>
              <nz-form-control [nzValidateStatus]="isFieldInvalid('contract') ? 'error' : null">
                <nz-select nzShowSearch nzAllowClear formControlName="contract"
                  [nzLoading]="isOptionsLoading" [nzPlaceHolder]="'Select contract term' | locale">
                  <nz-option *ngFor="let option of contractOptions" [nzLabel]="option.Name"
                    [nzValue]="option.Code"></nz-option>
                </nz-select>
                <div class="validation-message" *ngIf="isFieldInvalid('contract')">
                  {{ "Contract is required" | locale }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <nz-col nzXs="24" nzMd="12">
            <nz-form-item>
              <nz-form-label nzRequired>{{ "SLA" | locale }}</nz-form-label>
              <nz-form-control [nzValidateStatus]="isFieldInvalid('sla') ? 'error' : null">
                <nz-select nzShowSearch nzAllowClear formControlName="sla"
                  [nzLoading]="isOptionsLoading" [nzPlaceHolder]="'Select SLA' | locale">
                  <nz-option *ngFor="let option of slaOptions" [nzLabel]="option.Name"
                    [nzValue]="option.Code"></nz-option>
                </nz-select>
                <div class="validation-message" *ngIf="isFieldInvalid('sla')">
                  {{ "SLA is required" | locale }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>

          <nz-col nzXs="24" nzMd="12">
            <nz-form-item>
              <nz-form-label nzRequired>{{ "Service Layer" | locale }}</nz-form-label>
              <nz-form-control [nzValidateStatus]="isFieldInvalid('serverLayer') ? 'error' : null">
                <nz-select nzShowSearch nzAllowClear formControlName="serverLayer"
                [nzDisabled]="true"
                  [nzPlaceHolder]="'Select server layer' | locale">
                  <nz-option *ngFor="let option of serverLayerOptions" [nzLabel]="option"
                    [nzValue]="option"></nz-option>
                </nz-select>
                <div class="validation-message" *ngIf="isFieldInvalid('serverLayer')">
                  {{ "Server layer is required" | locale }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
        </nz-row>

        <div class="actions">
          <button nz-button nzType="primary" type="submit" [nzLoading]="isLoading" [disabled]="isLoading">
            <i nz-icon nzType="search"></i>
            {{ "Check Feasibility" | locale }}
          </button>
        </div>
      </form>
    </nz-card>

    <nz-alert *ngIf="errorMessage" class="state-alert error-alert" nzType="error" [nzMessage]="errorMessage"
      nzShowIcon></nz-alert>

    <nz-alert *ngIf="createDocumentErrorMessage" class="state-alert error-alert" nzType="error"
      [nzMessage]="createDocumentErrorMessage" nzShowIcon></nz-alert>

    <nz-card *ngIf="infoMessage" class="feasibility-panel empty-panel" [nzBordered]="false">
      <div class="state-card-content">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
        <div>
          <h3>{{ "No Options Found" | locale }}</h3>
          <p>
            {{
            "No feasible connectivity options were found for the supplied location and requirements."
            | locale
            }}
          </p>
        </div>
      </div>
    </nz-card>

    <nz-card *ngIf="results.length" class="feasibility-panel results-panel" [nzBordered]="false">
      <div class="panel-heading results-heading">
        <div>
          <h2>
            <i nz-icon nzType="check-circle" nzTheme="outline"></i>
            {{ "Connectivity Options" | locale }}
          </h2>
          <p>{{ "Feasible providers were found for this request." | locale }}</p>
        </div>
      </div>

      <div class="results-table-wrap">
        <nz-table #resultsTable [nzData]="results" [nzBordered]="false" [nzFrontPagination]="false" nzSize="small">
          <thead>
            <tr>
              <th class="select-column"></th>
              <th>{{ "Provider" | locale }}</th>
              <th>{{ "Type" | locale }}</th>
              <th>{{ "Speed" | locale }}</th>
              <th>{{ "SLA" | locale }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let result of resultsTable.data" [class.selected-result]="selectedResult === result"
              (click)="selectResult(result)">
              <td class="select-column">
                <button nz-button nzSize="small" type="button"
                  [nzType]="selectedResult === result ? 'primary' : 'default'"
                  (click)="selectResult(result); $event.stopPropagation()">
                  {{ selectedResult === result ? ("Selected" | locale) : ("Select" | locale) }}
                </button>
              </td>
              <td>{{ result.Provider }}</td>
              <td>{{ result.Type }}</td>
              <td>{{ result.Speed }}</td>
              <td>{{ result.SLA }}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>

      <div class="document-actions">
        <button nz-button nzType="primary" type="button" [nzLoading]="isCreating"
          [disabled]="!selectedResult || isCreating" (click)="createDocument()">
          <i nz-icon nzType="file-add"></i>
          {{ "Create Document" | locale }}
        </button>
      </div>
    </nz-card>
  </ng-container>

  <nz-card *ngIf="isDocumentCreated" class="feasibility-panel created-panel" [nzBordered]="false">
    <div class="created-content">
      <i nz-icon nzType="check-circle" nzTheme="outline"></i>
      <h2>{{ "Thank you" | locale }}</h2>
      <p>{{ createDocumentSuccessMessage }}</p>

      <div class="created-actions">
        <button nz-button nzType="primary"
          *ngIf="global.feasibilityModuleID != null && global.feasibilityModuleID !== undefined && global.feasibilityModuleID !== 0"
          type="button" (click)="viewCreatedDocument()">
          <i nz-icon nzType="file-text"></i>
          {{ "View Created Document" | locale }}
        </button>
        <button nz-button type="button"
          *ngIf="global.feasibilityModuleID != null && global.feasibilityModuleID !== undefined && global.feasibilityModuleID !== 0 && global.feasibilityLayoutID != null && global.feasibilityLayoutID !== undefined && global.feasibilityLayoutID !== 0"
          (click)="previewCreatedDocument()">
          <i nz-icon nzType="eye"></i>
          {{ "Preview" | locale }}
        </button>
        <button nz-button type="button" (click)="backToInitialPage()">
          <i nz-icon nzType="arrow-left"></i>
          {{ "Back" | locale }}
        </button>
      </div>
    </div>
  </nz-card>
</div>
